import { schema } from 'normalizr';

export const question = new schema.Entity('questions');

export const section = new schema.Entity('sections', {
  questions: [question],
});

export const celiSchema = new schema.Array(section);
